export default {
  depositionsHome: {
    title: ['What is', 'SIS'],
    subtitle: 'What does our team say about us?',
  },
}
